var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAinquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 14.5769C15.3896 14.5769 15.2135 14.7491 15.2135 14.9615V17.6154C15.2135 18.6758 14.3314 19.5385 13.2472 19.5385H9.00126C8.78414 19.5385 8.60816 19.7105 8.608 19.9228L8.60745 20.6875L7.66882 19.7695C7.60806 19.6331 7.46901 19.5385 7.30816 19.5385H4.75281C3.6686 19.5385 2.78652 18.6758 2.78652 17.6154V11.6923C2.78652 10.6319 3.6686 9.76923 4.75281 9.76923H8.72472C8.94188 9.76923 9.11798 9.59704 9.11798 9.38462C9.11798 9.17219 8.94188 9 8.72472 9H4.75281C3.23491 9 2 10.2078 2 11.6923V17.6154C2 19.0999 3.23491 20.3077 4.75281 20.3077H7.10678L8.72193 21.8873C8.79716 21.9609 8.89771 22 9.00008 22C9.05069 22 9.10178 21.9904 9.15034 21.9708C9.2973 21.9113 9.39314 21.7712 9.39326 21.6157L9.3942 20.3077H13.2472C14.7651 20.3077 16 19.0999 16 17.6154V14.9615C16 14.7491 15.8239 14.5769 15.6067 14.5769Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3225 2H15.3338C12.2032 2 9.65625 4.54695 9.65625 7.67758C9.65625 10.8082 12.2032 13.3551 15.3338 13.3551H16.3224C16.8111 13.3551 17.2947 13.293 17.7634 13.1704L19.2239 14.63C19.2986 14.7046 19.3984 14.7443 19.5001 14.7443C19.5504 14.7443 19.6012 14.7346 19.6495 14.7146C19.7955 14.6541 19.8906 14.5117 19.8906 14.3537V12.0937C20.5089 11.593 21.0226 10.9604 21.383 10.2538C21.7925 9.45121 22 8.58445 22 7.67758C22 4.54695 19.453 2 16.3225 2ZM19.265 11.5912C19.167 11.665 19.1094 11.7805 19.1094 11.9032V13.4111L18.1535 12.4557C18.0791 12.3814 17.9793 12.3413 17.8773 12.3413C17.839 12.3413 17.8004 12.347 17.7626 12.3586C17.2977 12.5015 16.8131 12.5739 16.3225 12.5739H15.3338C12.6339 12.5739 10.4375 10.3774 10.4375 7.67758C10.4375 4.97773 12.634 2.78125 15.3338 2.78125H16.3225C19.0223 2.78125 21.2188 4.97773 21.2188 7.67758C21.2188 9.22957 20.5066 10.6561 19.265 11.5912Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5872 6.27423C17.5309 5.45646 16.8717 4.79724 16.0538 4.74087C15.5903 4.70904 15.1478 4.8654 14.8092 5.18154C14.4752 5.49329 14.2837 5.934 14.2837 6.39068C14.2837 6.60642 14.4586 6.7813 14.6743 6.7813C14.89 6.7813 15.0649 6.60642 15.0649 6.39068C15.0649 6.14619 15.1635 5.91958 15.3423 5.75267C15.521 5.58591 15.7545 5.50337 16.0002 5.52033C16.431 5.55001 16.7782 5.89724 16.8079 6.32798C16.8379 6.76302 16.5524 7.14747 16.1292 7.24216C15.7863 7.31888 15.5469 7.61685 15.5469 7.96673V8.90521C15.5469 9.12095 15.7218 9.29583 15.9375 9.29583C16.1533 9.29583 16.3281 9.12095 16.3281 8.90521V7.99794C17.1152 7.80779 17.6433 7.08755 17.5872 6.27423Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2137 10.1745C16.141 10.1019 16.0402 10.0601 15.9375 10.0601C15.8348 10.0601 15.734 10.1019 15.6613 10.1745C15.5887 10.2472 15.5469 10.3479 15.5469 10.4507C15.5469 10.5538 15.5887 10.6546 15.6613 10.7272C15.734 10.7999 15.8348 10.8413 15.9375 10.8413C16.0402 10.8413 16.141 10.7999 16.2137 10.7272C16.2863 10.6542 16.3281 10.5538 16.3281 10.4507C16.3281 10.3479 16.2863 10.2472 16.2137 10.1745Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7422 14.1094H4.5C4.2843 14.1094 4.10938 14.2843 4.10938 14.5C4.10938 14.7157 4.2843 14.8906 4.5 14.8906H12.7422C12.9579 14.8906 13.1328 14.7157 13.1328 14.5C13.1328 14.2843 12.9579 14.1094 12.7422 14.1094Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0183 16.4113C12.9457 16.3387 12.8449 16.2969 12.7422 16.2969C12.6395 16.2969 12.5387 16.3387 12.466 16.4113C12.3933 16.484 12.3516 16.5848 12.3516 16.6875C12.3516 16.7902 12.3934 16.891 12.466 16.9637C12.5387 17.0363 12.6395 17.0781 12.7422 17.0781C12.8449 17.0781 12.9457 17.0363 13.0183 16.9637C13.091 16.891 13.1328 16.7906 13.1328 16.6875C13.1328 16.5848 13.091 16.484 13.0183 16.4113Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2057 16.2969H4.5C4.2843 16.2969 4.10938 16.4718 4.10938 16.6875C4.10938 16.9032 4.2843 17.0781 4.5 17.0781H11.2057C11.4215 17.0781 11.5964 16.9032 11.5964 16.6875C11.5964 16.4718 11.4214 16.2969 11.2057 16.2969Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2031 11.9219H4.5C4.2843 11.9219 4.10938 12.0968 4.10938 12.3125C4.10938 12.5282 4.2843 12.7031 4.5 12.7031H10.2031C10.4189 12.7031 10.5938 12.5282 10.5938 12.3125C10.5938 12.0968 10.4188 11.9219 10.2031 11.9219Z",
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAinquiry);
export default __webpack_public_path__ + "static/media/Ainquiry.3bf88b5f82e4d955e3358341ad712e2e.svg";
export { ForwardRef as ReactComponent };